/*eslint-disable*/
import React, {useEffect, useState} from "react";
import PasswordChecklist from "react-password-checklist";

import '../../assets/styles/App.css';
import "@fontsource/montserrat";


export default function UserCreatePopUp({ onSave, isOpen, onClose }) {
    const [errorMessage, setErrorMessage] = useState('');
    const [userEdited, setUserEdited] = useState({
        email: "",
        password: "",
        firstName: "",
        lastName: ""
    });


    useEffect(() => {

    }, []);

    if (!isOpen) return null;

    const generatePassword = () => {
        let charset = "";
        let newPassword = "";

        charset += "!@#$%^&*()";
        charset += "0123456789";
        charset += "abcdefghijklmnopqrstuvwxyz";
        charset += "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

        for (let i = 0; i < 8; i++) {
            newPassword += charset.charAt(Math.floor(Math.random() * charset.length));
        }

        return newPassword;
    };

    const handleChange = (e) => {
        const {name, value} = e.target;
        setUserEdited((prevUser) => ({
            ...prevUser,
            [name]: value
        }));
    };

    const onSubmit = (event) => {
        event.preventDefault();

        let p = generatePassword();

        setUserEdited({...userEdited, email: userEdited.email});
        setUserEdited({...userEdited, password: p});
        setUserEdited({...userEdited, firstName: userEdited.firstName});
        setUserEdited({...userEdited, lastName: userEdited.lastName});

        onSave(userEdited);
    };



    return (
        <>
                <div className="bg-dark-transparent fixed w-full flex h-screen bottom-0 z-100 px-4">
                    <div className="w-full h-full flex items-center">
                        <div className="mx-auto bg-white rounded-lg max-w-600-px py-10">
                            <div className="mb-6 rounded-t-lg">
                                <h2 className="text-24-150-no-change text-blue-v-dark text-center">Create User</h2>                                
                            </div>

                            <form onSubmit={onSubmit}>
                                <div className="px-8">
                                    <div className="mb-6">

                                        <div>
                                            <label className="text-16-600 text-blue-v-dark" htmlFor="email">Email address</label>
                                        </div>
                                        <div className="mb-4">
                                            <input
                                                className="h-45-px w-full border-light-grey rounded-sm"
                                                type="email"
                                                name="email"
                                                value={userEdited.email}
                                                onChange={handleChange}>
                                            </input>
                                        </div>

                                    </div>

                                    <div className="mb-6">

                                        <div>
                                            <label className="text-16-600 text-blue-v-dark" htmlFor="email">First Name</label>
                                        </div>
                                        <div className="mb-4">
                                            <input
                                                className="h-45-px w-full border-light-grey rounded-sm"
                                                type="text"
                                                name="firstName"
                                                value={userEdited.firstName}
                                                onChange={handleChange}>
                                            </input>
                                        </div>

                                    </div>


                                    <div className="mb-6">

                                        <div>
                                            <label className="text-16-600 text-blue-v-dark" htmlFor="email">Last Name</label>
                                        </div>
                                        <div className="mb-4">
                                            <input
                                                className="h-45-px w-full border-light-grey rounded-sm"
                                                type="text"
                                                name="lastName"
                                                value={userEdited.lastName}
                                                onChange={handleChange}>
                                            </input>
                                        </div>

                                    </div>


                                    <div className="flex justify-center mt-8">
                                        <button
                                            className="bg-yellow text-16-19 text-blue-v-dark py-2 px-12 rounded"
                                            type="submit"
                                        >
                                            <i className="fa fa-address-card" aria-hidden="true"></i>
                                                                                        
                                            &nbsp; Create User &nbsp;
                                        </button>
                                        <button
                                            className="text-16-19 px-12 py-2 ml-3 items-center text-blue rounded"
                                            type="button"
                                            onClick={onClose}
                                        >
                                            <i className="fa fa-times" aria-hidden="true"></i>

                                            &nbsp;&nbsp; Close &nbsp;&nbsp;
                                        </button>
                                    </div>
                                </div>
                            </form>


                        </div>
                    </div>
                </div>

        </>
    );
}